// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

interface IHooksService {
   on: any
   off: any
   once: any
   fire: any

}
class HooksService {
   hooks: any
   hooksOnce: any
   constructor() {
      this.hooks = {}
      this.hooksOnce = {}
   }

   setHooks(service: any, serviceName: any, hookHandlers: any, withId = false) {

      this.populateHooksHandlers(serviceName, hookHandlers)

      if (withId) {
         return this.applyIdHooksToService(service, serviceName)
      } else {
         return this.applyHooksToService(service, serviceName)
      }
   }

   populateHooksHandlers(serviceName: any, hookHandlers: any){
      if (hookHandlers.indexOf('__nonIDable') > -1) {
         throw new Error("Can't set hooks to '__nonIDable' handler")
      }

      // Preset handlers
      if (!this.hooks.hasOwnProperty(serviceName)) {

         this.hooks[serviceName] = {__nonIDable: {}}
         this.hooksOnce[serviceName] = {__nonIDable: {}}

         for (const hookHandler of hookHandlers) {
            this.hooks[serviceName][hookHandler] = {}
            this.hooks[serviceName]['__nonIDable'][hookHandler] = []

            this.hooksOnce[serviceName][hookHandler] = {}
            this.hooksOnce[serviceName]['__nonIDable'][hookHandler] = []
         }
      }
   }

   applyHooksToService(service: any, serviceName: any){
      service.on = (message: any, callback: any) => {
         if (this.hooks[serviceName][message] == null) {
            throw new Error(`Can't subscribe to '${message}': event does not exist`)
         }
         if (this.hooks[serviceName]['__nonIDable'][message].indexOf(callback) === -1) {
            return this.hooks[serviceName]['__nonIDable'][message].push(callback)
         }
      }

      service.once = (message: any, callback: any) => {
         if (this.hooksOnce[serviceName][message] == null) {
            throw new Error(`Can't subscribe to '${message}': event does not exist`)
         }
         return this.hooksOnce[serviceName]['__nonIDable'][message].push(callback)
      }

      service.off = (message: any, callback: any) => {
         let index
         if ((index = this.hooks[serviceName]['__nonIDable'][message].indexOf(callback)) > -1) {
            return this.hooks[serviceName]['__nonIDable'][message].splice(index, 1)
         }
      }

      service.fire = (message:any, ...args: any ) => {
         let shoot
         this.hooks[serviceName]['__nonIDable'][message]
            .forEach((callback: any) =>
               callback.apply(service, args))
         
         while ((shoot = this.hooksOnce[serviceName]['__nonIDable'][message]?.shift())) { shoot?.apply(service, args) }
      }
   }

   applyIdHooksToService(service: any, serviceName: any){
      service.on = (message: any, id: any, callback: any) => {
         if (this.hooks[serviceName][message] == null) {
            throw new Error(`Can't subscribe to '${message}': event does not exist`)
         }
         this.hooks[serviceName][message][id] = callback
      }

      service.once = (message: any, callback: any) => {
         if (this.hooksOnce[serviceName][message] == null) {
            throw new Error(`Can't subscribe to '${message}': event does not exist`)
         }
         // @ts-expect-error TS(2304) FIXME: Cannot find name 'id'.
         this.hooksOnce[serviceName][message][id] = callback
      }

      service.off = (message: any, id: any) => {
         if (this.hooks[serviceName][message] == null) {
            throw new Error(`Can't unsubscribe from '${message}': event does not exist`)
         }
         delete this.hooks[serviceName][message][id]
      }

      service.fire = (message: any, ...args: any) => {
         
         _.each(this.hooks[serviceName][message],
            (callback: any) =>
               callback.apply(service, args)
         )
         
         _.each(this.hooksOnce[serviceName][message], (callback: any, id: any) => {
            callback.apply(service, args)
            delete this.hooksOnce[serviceName][message][id]
         })
      }
   }
}


HooksService.$inject = []

angular.module('summonApp.services')
   .service('hooksService', HooksService)
